//WEBAPI_BASE_URL : "https://idcom-framework-webapi.azurewebsites.net/api"
const env = {
	WEBAPI_BASE_URL : "https://idcom-framework-webapi.azurewebsites.net/api",
    DEVTOOLS_ENABLED : false,
    APPLICATION_ID: 'e10fd47c-09ed-4094-a305-fb20bb49af41'
}
export default env;


// WEBPACK FOOTER //
// ./src/configs/config.prod.js